
















import Vue, {VueConstructor} from 'vue'

export default (Vue as VueConstructor<Vue & {
  $refs: {
    textarea: HTMLElement
  }
}>).extend({
  name: 'UiTextareaInput',
  props: {
    name: {},
    value: String,
    placeholder: {},
    readOnly: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    type: String,
    rows: {
      type: Number,
      default: 3
    },
    error: Boolean
  },
  data () {
    return {
      focused: false,
      minHeight: 0
    }
  },
  methods: {
    onBlur (event: UIEvent) {
      this.$emit('blur', event)
      this.focused = false;
    },
    onInput (event: any) {
      event.target.style.height = '5px';
      event.target.style.height = (event.target.scrollHeight)+'px';
      this.$emit('input', event.target.value)
    },
    onFocus (event: UIEvent) {
      this.focused = true;
      this.$emit('focus', event)
    }
  },
  computed: {
    currentValue: {
      get (): string {
        return this.value || ''
      },
      set () {
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.minHeight = this.$refs.textarea.scrollHeight
    });
  }
})
